var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "destroy-on-close": false,
        top: "5vh",
        title: "",
        width: "600px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            _vm._l(_vm.lists, function(item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.label,
                  attrs: { label: item.label, name: item.label, lazy: true }
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.value,
                        expression: "item.value"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "400px"
                    },
                    attrs: { readonly: "", no: "1" },
                    domProps: { value: item.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "value", $event.target.value)
                      }
                    }
                  })
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "30px" },
              attrs: { type: "primary", no: "2" },
              on: {
                click: function($event) {
                  return _vm.ediImportClickHandler()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.exportThisPageEdi")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "30px" },
              attrs: { type: "default", no: "3" },
              on: {
                click: function($event) {
                  return _vm.closeHandler()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }